//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions, mapGetters } from 'vuex';
import DeviceSelect from '@/components/DeviceSelect.vue';
import constant from '~/const';

export default {
  components: { DeviceSelect },
  props: {
    value: { type: Boolean, default: false },
    data: { type: Object, default: () => ({}) },
    isCreating: { type: Boolean, default: false },
  },

  data() {
    return {
      input: {},
      constant,
      currentFields: [],
      isCollapsed: true,
      maxLength: 20,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapState('tradersCurrencies', { currencies: 'data' }),
    ...mapState('tradersPaymentMethods', { p2pPaymentMethods: 'data' }),
    ...mapGetters('tradersPaymentMethods', ['getMethodById']),

    codeStyle() {
      return {
        backgroundColor: '#4a4a4a',
        color: '#ffffff',
        cursor: 'pointer',
        display: 'block',
        padding: '10px',
        borderRadius: '4px',
      };
    },

    preStyle() {
      return {
        whiteSpace: 'pre-wrap', // позволяет переносить длинные строки
        wordBreak: 'break-all', // переносит слова, если они слишком длинные
      };
    },

    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isApplyPossible() {
      return this.input?.name;
    },
  },

  watch: {
    value(val) {
      if (val) {
        const {
          isCreating, data,
        } = this;
        if (!isCreating) {
          const model = { requisitesId: data.id };
          this.$set(this, 'input', { ...model, ...data });
          this.currentFields = data.paymentMethod.fields;
        } else {
          this.$set(this, 'input', {});
        }
      }
    },
  },

  methods: {
    ...mapActions('common', [
      'setErrorNotification',
      'setGeneralLoader',
    ]),
    ...mapActions('templates', {
      loadTemplates: 'loadData',
    }),

    async onPaymentMethodChange() {
      this.setGeneralLoader(true);
      await this.loadTemplates();
      const selectedMethod = this.getMethodById(this.input.paymentMethodId);
      if (selectedMethod && selectedMethod.fields) {
        this.currentFields = selectedMethod.fields;
      } else {
        this.currentFields = this.$props.data.paymentMethod.fields || [];
      }
      this.setGeneralLoader(false);
    },

    toggleRegex() {
      this.isCollapsed = !this.isCollapsed;
    },

    formattedRegex(regex) {
      return regex.replace(/(.{50})/g, '$1\n');
    },

    collapsedRegex(regex) {
      return regex.length > this.maxLength
        ? `${regex.slice(0, this.maxLength)}...`
        : regex;
    },

    apply() {
      const { input } = this;
      const userId = String(this.$route.params.id);
      const payload = { ...input, userId };

      if (input.deviceId) {
        payload.deviceId = String(input.deviceId);
      }

      this.$emit('apply', payload);
    },
  },
};
